export default __webpack_public_path__ + "static/media/add-user-enabled.cad5747e.svg";